const TYPEAHEAD_URL = 'https://json.edhrec.com/static/typeahead/commanders'

let cachedCommanders: string[] | null = null

export const getCommandersTypeahead = async (): Promise<string[]> => {
  if (cachedCommanders && cachedCommanders.length) return cachedCommanders

  let commanders: string[] = []
  try {
    const response = await fetch(TYPEAHEAD_URL)
    const data = await response.json()
    commanders = data
  } catch (error) {
    console.error(error)
  }
  cachedCommanders = commanders
  return commanders
}
